const trigger = (el, type) => {
    const e = document.createEvent('HTMLEvents');
    e.initEvent(type, true, true);
    el.dispatchEvent(e);
};
/** 
 * 自定义数字验证
 * 指令名称：v-Int (默认限制输入0-9数字)
 * 指令修饰符：v-Int.float (默认显示输入0-9.数字及小数点)
 * 指令参数：v-Int={isNegative:true} or v-Int.float={isNegative:true}  （允许输入负数）
 * 指令参数：v-Int={noZero:true} （不允许输入0）
 */
export default {
    bind: function (el, binding) {
        const isFloat = binding.modifiers.float;
        let params = binding.value;
        const input = el.tagName === 'INPUT' ? el : el.querySelector('input');
        input.onkeyup = function (e) {
            if (isFloat) {  // 小数
                if (params && params.isNegative) {  // 小数且负数
                    if (/[\-]/.test(input.value)) {
                        input.value = '-' + input.value.replace(/[^0-9.]/g, '');
                    } else {  
                        input.value = input.value.replace(/[^0-9.]/g, '');
                    }
                } else if(params && params.noZero) { // 小数且非0
                    if(input.value <= 0){
                        input.value = ''
                    }else{
                        input.value = input.value.replace(/[^0-9.]/g, '');
                    }
                }  else { // 仅仅小数
                    input.value = input.value.replace(/[^0-9.]/g, '');
                }
            } else if (params && params.isNegative) { // 整数且负数
                if (/[\-]/.test(input.value)) {
                    input.value = '-' + input.value.replace(/[^0-9.]/g, '');
                } else {
                    input.value = input.value.replace(/[^0-9.]/g, '');
                }
            } else {  // 正整数
                if(params && params.noZero) { // 正整数且非0
                    input.value = input.value.replace(/[^1-9.]/g, '');
                }  else { // 仅仅正整数
                    input.value = input.value.replace(/[^0-9.]/g, '');
                }
            }
            trigger(input, 'input');
        };
    }
};